<template>
  <div>
    <div v-if="areContactsLoaded">
      <b-form @submit="createContact" class="mb-4">
        <b-form-group label="Name" label-for="contact-name">
          <b-form-input id="contact-name" v-model="contact.name" required maxlength="40" />
        </b-form-group>
        <b-form-group label="Phone number">
          <E164PhoneNumberInput v-model="contact.phone_number" :required="false" />
          <b-form-invalid-feedback :state="isValidPhoneNumber">
            Please enter a valid phone number.
          </b-form-invalid-feedback>
          <b-form-text v-if="isValidPhoneNumber !== false">
            Optional, but it will be easier for you to send a text right away if you include a number.
          </b-form-text>
        </b-form-group>
        <b-button type="submit" variant="primary" :disabled="isSavingContact">Add</b-button>
      </b-form>

      <b-card v-if="contacts.length == 0" class="contacts-none">
        <b-card-text>
          You haven't added any contacts yet. Add some above. You will get a reminder to reach out to one of them every morning.
        </b-card-text>
      </b-card>
      <b-table v-else striped hover :items="contacts" :fields="tableFields">
        <template v-slot:cell(delete)="data">
          <b-link href="#" v-on:click="deleteContact(data.item.id)">X</b-link>
        </template>
      </b-table>
    </div>
    <b-spinner v-else label="Loading..." />
  </div>
</template>

<script>
import { BButton, BCard, BCardText, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BFormText, BLink, BSpinner, BTable } from 'bootstrap-vue'
import E164PhoneNumberInput from '../common/e164_phone_number_input';
import GenericErrorMixin from '../../libs/generic_error_mixin'
import { jsonApi } from '../../libs/jsonapi'

export default {
  mixins: [GenericErrorMixin],
  mounted: async function () {
    try {
      const response = await this.jsonApi.findAll('contact');
      this.contacts = response.data;
      this.areContactsLoaded = true;
    }
    catch (error) {
      this.showGenericErrorModal();
    }
  },
  data: function () {
    return {
      areContactsLoaded: false,
      contact: {},
      contacts: [],
      isSavingContact: false,
      isValidPhoneNumber: null,
      jsonApi: jsonApi,
      profile: {},
      tableFields: [
        {key: 'name', label: 'Name', sortable: true},
        {key: 'formatted_phone_number', label: 'Phone'},
        {key: 'delete', label: ''}
      ]
    }
  },
  computed: {
    tableContacts() {

    }
  },
  methods: {
    async createContact(evt) {
      evt.preventDefault();
      this.isSavingContact = true;
      this.isValidPhoneNumber = true;

      try {
        const response = await this.jsonApi.create('contact', this.contact);
        this.contacts.unshift(response.data);
      } catch (error) {
        if (error.phone_number) {
          this.isValidPhoneNumber = false;
        } else {
          this.showGenericErrorModal();
        }
        return;
      } finally {
        this.isSavingContact = false;
      }

      this.contact = {};
    },
    async deleteContact(id) {
      try {
        await this.jsonApi.destroy('contact', id);
        this.contacts = this.contacts.filter((item) => item.id != id);
      } catch (error) {
        this.showGenericErrorModal();
      }
    }
  },
  components: {
    'b-button': BButton,
    'b-card': BCard,
    'b-card-text': BCardText,
    'b-form': BForm,
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput,
    'b-form-invalid-feedback': BFormInvalidFeedback,
    'b-form-text': BFormText,
    'b-link': BLink,
    'b-spinner': BSpinner,
    'b-table': BTable,
    E164PhoneNumberInput
  }
}
</script>

<style scoped>
.contacts-none {
  background-color: #fcfae1;
}
</style>